import { defineStore } from "pinia";
import cookiesHelper from "@/helper/cookiesHelper";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        user: null,
    }),
    actions: {
        set_user(user) {
            this.user = user;
        },
        async me() {
            const token = cookiesHelper.getCookie("_token");

            if (token) {
                return axios
                    .get("user/me")
                    .then(({ data }) => {
                        this.user = data.user;

                        return data;
                    })
                    .catch((error) => {
                        this.user = null;
                        throw error;
                    });
            }
        },
        async logout() {
            return axios
                .post("/logout")
                .then((response) => {
                    cookiesHelper.clearCookie("_token");
                })
                .catch((error) => {
                    console.error(error);
                    throw error;
                });
        },
    },
    getters: {
        currentUser: (state) => state.user,
    },
});
